/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * (german: Wirtschaftszweig, Geschäftszweig)   (bipro-datentypen::BerufsBranche)     * `ConstructionCraft`     - german: Baugewerbe/Handwerk   * `Mining`                - german: Bergbau   * `EnergyWater`           - german: Energie-/Wasserversorgung   * `Financing`             - german: Finanz- und Versicherungsdienstleister   * `Hospitality`           - german: Gastgewerbe   * `NonProfitOrganization` - german: gemeinnützige/mildtätige Einrichtung   * `HealthSocial`          - german: Gesundheits- und Sozialwesen   * `Housing`               - german: Grundstücks- und Wohnungswesen   * `Trade`                 - german: Handel   * `Industry`              - german: Industrie/verarbeitendes Gewerbe   * `Agriculture`           - german: landwirtschaftliche Unternehmen   * `PublicService`         - german: öffentliche Verwaltung, Sozialversicherung   * `OtherServices`         - german: sonstige Dienstleistungen   * `Others`                - german: sonstiges
 */
export const OccupationBranche = {
  ConstructionCraft: 'ConstructionCraft',
  Mining: 'Mining',
  EnergyWater: 'EnergyWater',
  Financing: 'Financing',
  Hospitality: 'Hospitality',
  NonProfitOrganization: 'NonProfitOrganization',
  HealthSocial: 'HealthSocial',
  Housing: 'Housing',
  Trade: 'Trade',
  Industry: 'Industry',
  Agriculture: 'Agriculture',
  PublicService: 'PublicService',
  OtherServices: 'OtherServices',
  Others: 'Others',
} as const;
export type OccupationBranche = (typeof OccupationBranche)[keyof typeof OccupationBranche];
